import { Bird, LifeBuoy, Heart, Lock } from "lucide-react";

interface BenefitsSectionProps {
  className?: string;
}

interface BenefitCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

function BenefitCard({ icon, title, description }: BenefitCardProps) {
  return (
    <div className="p-6 rounded-2xl bg-[#F4E7DA]/5 backdrop-blur-sm border border-[#F4E7DA]/10 hover:bg-[#F4E7DA]/10 transition-all duration-300 group">
      <div className="mb-4 group-hover:scale-110 transition-transform duration-300">
        {icon}
      </div>
      <h3 className="text-xl font-semibold mb-3 text-midnight-blue">{title}</h3>
      <p className="text-midnight-blue/80 leading-relaxed">{description}</p>
    </div>
  );
}

export default function BenefitsSection({
  className = "",
}: BenefitsSectionProps) {
  return (
    <section className={`px-4 py-16 ${className}`}>
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-midnight-blue">
            Vì Sự An Tâm Của Mẹ Là Vô Giá
          </h2>
          <p className="text-lg text-midnight-blue/80 max-w-3xl mx-auto">
            Hãy để Locuno gánh vác những lo âu, để bạn có thể tận hưởng trọn vẹn
            từng khoảnh khắc hạnh phúc bên gia đình.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          <BenefitCard
            icon={<Bird className="w-8 h-8 text-green-700" />}
            title="Cho Con Tự Do, Cho Mẹ An Lòng"
            description="Con thoải mái khám phá thế giới trong vòng tay bảo vệ của bạn. Dù ở trường, ở khu vui chơi hay đang trên đường về nhà, bạn luôn biết con an toàn."
          />
          <BenefitCard
            icon={<LifeBuoy className="w-8 h-8 text-red-600" />}
            title="Luôn Bên Cạnh Khi Con Cần Nhất"
            description="Trong những tình huống bất ngờ, nút SOS là cầu nối tức thì giữa con và cả gia đình. Hành động kịp thời, bảo vệ con khỏi mọi rủi ro."
          />
          <BenefitCard
            icon={<Heart className="w-8 h-8 text-rose-600" />}
            title="Sợi Dây Yêu Thương Vô Hình"
            description="Sự quan tâm không cần lời nói. Locuno giúp bạn thể hiện tình yêu thương một cách tinh tế, để con luôn cảm nhận được sự che chở của gia đình."
          />
          <BenefitCard
            icon={<Lock className="w-8 h-8 text-blue-700" />}
            title="Riêng Tư Của Gia Đình Là Tuyệt Đối"
            description="Chúng tôi xem việc bảo vệ dữ liệu của bạn là sứ mệnh hàng đầu. Công nghệ bảo mật tiên tiến nhất giữ mọi thông tin gia đình an toàn tuyệt đối."
          />
        </div>
      </div>
    </section>
  );
}
